<mat-select panelClass="mat-option-custom" [value]="currentLot?.LotId" (selectionChange)="handleLotSelection($event.value, $event)"
  [placeholder]="lotLabel" [aria-label]=" lotLabel + ' Selector'">
  @if (!disableViewAllOption) {
    <mat-option [value]="viewAllValue">
      <icon [class.is-inventory-home]="isInventoryHome" name="arrow_right"></icon>View All
    </mat-option>
  }
  @for (lot of selectOptionsLots; track lot) {
    <mat-option [value]="lot.LotId" [attr.aria-label]="lotLabel + lot.Title">
      <icon name="arrow_right"></icon>{{lot.Title}}
    </mat-option>
  }
</mat-select>